{
  "FRONTEND": {
    "STORE": {
      "TOTAL": "Total",
      "SUBTOTAL": "Subtotal",
      "TAX": "Tax ({{percentage}}%)",
      "RECURRING_CHARGES_SUMMARY": {
        "TITLE": "Recurring charges summary",
        "NO_RECURRING_CHARGES": "No recurring charges"
      },
      "CANNOT_ADD_TO_CART_TOOLTIP": "This product can't be added to your cart right now. Please contact us directly to purchase this product.",
      "CAN_ENABLE_PRODUCTS_PERMISSION_DISABLED_TOOLTIP": "Contact an admin to start selling this product or update your user permissions.",
      "CONTRACT_DURATION": "Contract duration",
      "CONTACT_SALES": "Contact Sales",
      "CONTACT_US": "Contact us",
      "MESSAGE_US": "Message us",
      "FREE": "Free",
      "STARTING_AT": "Starting at",
      "ESTIMATED_VALUE": "Estimated value",
      "ENABLED_UPPER": "ENABLED",
      "ENABLE_UPPER": "ENABLE",
      "MIN_TO_MAX": "{{minRange}} to {{maxRange}}",
      "PRODUCT_PRICING_WITH_FREQUENCY": "{{pricingTier}} accounts {{frequency}}",
      "COMMITMENT_WITH_RENEWAL": "*{{initial}} {{frequencyString}} minimum, renews for {{recurring}} {{frequencyString}} periods",
      "COMMITMENT": "${{initial}} ${{frequencyString}} commitment",
      "PRICING_FREQUENCIES": {
        "MONTH": "month",
        "YEAR": "year"
      },
      "REQUIRES_DESCRIPTOR": "(Requires {{requirementName}})",
      "ADMINISTRATIVE_QUESTIONS": "Administrative Questions",
      "AUTO_TITLE_TEXT": {
        "SOME_FIELDS_INVALID": "Fields require your attention",
        "OPTIONAL_FIELDS_UNANSWERED": "Optional fields unanswered",
        "COMPLETE": "Complete"
      },
      "REQUIRES": "Requires",
      "ENABLED_WITH_PREREQUISITE": "Enabled with {{prerequisite}}",
      "ENABLE_WITH_PREREQUISITE": "Enable with {{prerequisite}}",
      "PRICE_APPLIES_PER_UNIT": "Price applies per unit within a range",
      "PRICE_APPLIES_TO_ALL_UNITS": "Price applies to all units once range is met",
      "PRICING": "Pricing",
      "PRICE": "Price",
      "WHOLESALE_COST": "Wholesale Cost",
      "FAQS": "FAQs",
      "GALLERY": "Gallery",
      "FILES": "Files",
      "GET_IT_NOW": "Get It Now",
      "CONTAINS_NUM_ITEMS": "Contains {{itemCount}} items",
      "ENABLED_STATE": {
        "ENABLED": "Enabled",
        "ENABLE": "Enable",
        "ADD_ON": {
          "ENABLE": "Enable Add-on"
        }
      },
      "STORE_STATE": {
        "START_SELLING": "Start selling",
        "STOP_SELLING": "Stop selling",
        "SELLING": "Selling",
        "ADD_ON": {
          "START_SELLING": "Start selling Add-on"
        }
      },
      "MORE": "More",
      "TAGS": "Tags",
      "COMMIT": "commitment",
      "INITIAL": "Initial",
      "RECURRING": "recurring every",
      "ACTIVATIONS": "Activations",
      "ACCOUNTS": "accounts",
      "ADD_ONS": "Add-Ons",
      "REQUIRED": "Required",
      "PERIODS": {
        "YEARLY": "Yearly",
        "MONTHLY": "Monthly",
        "WEEKLY": "Weekly",
        "ONE_TIME": "One time",
        "BIWEEKLY": "Bi-weekly",
        "DAILY": "Daily"
      },
      "DURATION": {
        "DAY_CONTRACT": "The duration of this contract is {{value}} day(s)",
        "WEEK_CONTRACT": "The duration of this contract is {{value}} week(s)",
        "MONTH_CONTRACT": "The duration of this contract is {{value}} month(s)",
        "YEAR_CONTRACT": "The duration of this contract is {{value}} year(s)"
      },
      "ORDER_FORM": {
        "CONTACT_DESCRIPTION": "They may be contacted regarding fulfillment",
        "CONTACT_LABEL": "Who is the main point of contact?",
        "FIELD_TYPE_REQUIRED": "Form field type is required",
        "FOR_OFFICE_USE_ONLY": "For office use only",
        "HIDDEN_FROM_END_USERS": "Hidden from end users",
        "FOR_OFFICE_USE_ONLY_TOOLTIP": "This question will not be shown to end users",
        "OFFICE_EDITABLE_ONLY": "Office editable only",
        "OFFICE_EDITABLE_ONLY_TOOLTIP": "Answers to this question cannot be changed by end users",
        "OPTION": "Option",
        "VALUE": "Value",
        "ASSIGN_VALUE": "Assign value",
        "CLEAR_BUTTON": "Clear button",
        "ALLOW_MULTIPLES": "Allow multiples",
        "ALLOW_DUPLICATES": "Allow duplicates",
        "MAX_NUM_CHOICES": "Maximum number of choices",
        "CHOICES_HINT": "Must be greater than {{minChoices}}",
        "CHOICES_ERROR": "Max Choices must be a number larger than {{minChoices}}",
        "LABEL_HINT": "Keep it short. Recommended: Max {{maxCharacters}} characters",
        "LABEL_ERROR": "Label is required",
        "HIDE_PREFIX_SUFFIX": "Hide Prefix/Suffix",
        "PREFIX_SUFFIX": "Prefix/Suffix",
        "HIDDEN_NOTE": "Values will apply even though currently hidden",
        "ID_HINT": "ID must be unique",
        "ID_ERROR": "ID is required",
        "UPLOAD_URL": "Upload URL",
        "UPLOAD_URL_HINT": "An upload url will be provided if this field is left blank",
        "REGEX_VALIDATOR": "Regex validator",
        "REGEX_VALIDATOR_ERROR": "Must be a valid regular expression",
        "REGEX_ERROR_MESSAGE": "Regex error message",
        "REGEX_ERROR_MESSAGE_HINT": "Error displayed to the user when the regular expression is not matched",
        "VALIDATION": "Validation",
        "HIDE_VALIDATION": "Hide validation",
        "HINT_TEXT": "Hint text",
        "HINT_TEXT_HINT": "Hint text appears below the field. Use it to offer context or examples of the information to provide.",
        "DELETE_FIELD": "Delete field",
        "NO_USERS_INSTRUCTIONS": "No Users — Please add one to this account",
        "FIELD_TYPES": {
          "FILES": "Files",
          "DROP_DOWN": "Drop Down",
          "CHECK_BOX": "Check Box",
          "TEXT_AREA": "Text Area",
          "TEXT_BOX": "Text Box",
          "END_USER": "End User"
        },
        "LABELS": {
          "COMMON_FORM_HEADER_TITLE": "Gather activation information",
          "COMMON_FORM_HEADER_TEXT": "The following information will be provided to the products that require it.",
          "COMMON_FORM_EDITING_HINT": "Editing this information does not update the account",
          "BUSINESS_SECTION_TITLE": "Business",
          "SALESPERSON_SECTION_TITLE": "Salesperson",
          "CONTACT_SECTION_TITLE": "Contact",
          "BUSINESS_NAME": "Business Name",
          "BUSINESS_ADDRESS": "Business Address",
          "BUSINESS_PHONE_NUMBER": "Business Phone Number",
          "BUSINESS_WEBSITE": "Business Website",
          "BUSINESS_ID": "Business ID",
          "SALESPERSON_NAME": "Salesperson Name",
          "SALESPERSON_PHONE_NUMBER": "Salesperson Phone Number",
          "SALESPERSON_EMAIL": "Salesperson Email",
          "CONTACT_NAME": "Contact Name",
          "CONTACT_PHONE_NUMBER": "Contact Phone Number",
          "CONTACT_EMAIL": "Contact Email"
        },
        "ACCURATE_INFO_PROMPT": "Review to ensure accurate information",
        "ACCOUNT_INFO_TITLE": "{{ name }}'s information",
        "ACCOUNT_DETAILS": "Account details",
        "EDIT_BUSINESS_DETAILS_DISCLAIMER": "Editing this information does not update the business details",
        "EDIT_RESELLER_DETAILS_DISCLAIMER": "Editing this information does not update the contact details",
        "PLEASE_REVIEW": "Please review",
        "ACCOUNT_CONTACT": "Account contact",
        "RESELLER_INFO_TITLE": "{{ name }}'s primary contact",
        "PARTNER_CONTACT": "Partner contact",
        "ADMINISTRATIVE_INFO": "Administrative information",
        "ORDER_FORMS": "Order forms",
        "ORDER_FORMS_SUBTITLE": "Additional information is needed for items in this order",
        "ACCOUNT": "Account",
        "RESELLER": "Reseller"
      },
      "ACTIVATION_STATUS": {
        "ACTIVATED": "Activated",
        "ALREADY_ACTIVATED": "Already Activated",
        "ACTIVATION_ERRORS": "Activation Errors",
        "ACTIVATION_ERRORS_OCCURRED": "Activation Errors Occured",
        "ACTIVATION_WARNINGS": "Activation Warnings"
      },
      "SEE_ALL": "See all",
      "NOT_AVAILABLE_IN_YOUR_COUNTRY": "Not available in your country",
      "AVAILABLE_IN": "AVAILABLE IN",
      "ALL_COUNTRIES": "All countries",
      "NEED_HELP": "Need help",
      "VIDEOS": "Videos",
      "STOREFRONT_FILTERS": {
        "TITLE": "Store Filters",
        "CATEGORIES": "Categories",
        "LMI_CATEGORY": "LMI Category"
      },
      "LMI_CATEGORIES": {
        "LISTINGS": "Listings",
        "SOCIAL": "Social",
        "REPUTATION": "Reputation",
        "SEO": "SEO",
        "WEBSITE": "Website",
        "ADVERTISING": "Advertising",
        "CONTENT_AND_EXPERIENCE": "Content + Experience"
      },
      "PRODUCTS_AND_ADDONS": "Related Products & Add-ons",
      "ADD_TO_CART": "Add to cart",
      "BUY_IT_NOW": "Buy it now",
      "ERROR_PRODUCT": "There was a problem loading the product",
      "PRODUCT_DETAILS": {
        "TAB_LABELS": {
          "PRODUCT_INFORMATION": "Product Information",
          "SCREENSHOTS_AND_FILES": "Screenshots & Files",
          "EDITIONS_AND_PRICING": "Editions & Pricing"
        },
        "PRODUCT_REQUIREMENTS": {
          "LABEL": "REQUIRED PRODUCTS",
          "TOOLTIP": {
            "TITLE": "Required products",
            "INTERNAL_DESCRIPTION": "Required products need to be already active on a customer's account before they can buy or use this product.",
            "EXTERNAL_DESCRIPTION": "You’ll need these required products before you can buy or use this product."
          }
        },
        "PREVIEW_FORMS": {
          "LABEL": "REQUIRED FORMS",
          "ORDER_FORM": "Order form",
          "FULFILLMENT_FORM": "Fulfillment form",
          "ORDER_FORM_PREVIEW": "Order form preview",
          "ORDER_FORM_PREVIEW_ALERT": "This is a preview of the order form used when purchasing this product. This preview is for display purposes only. No input in this preview will be saved.",
          "TOOLTIP": {
            "TITLE": "Required forms",
            "DESCRIPTION": "Order form information is required at the time of purchase. Fulfillment form information is required after purchase."
          }
        }
      },
      "EDITION_SELECTOR": {
        "ADD_APP_SELECTION": {
          "TITLE": "Choose an edition"
        },
        "ADD_DEPENDANT_SELECTION": {
          "TITLE": "Choose an edition of {{productName}}",
          "EXPLANATION": "{{childName}} is a dependent of {{productName}}, which you haven’t already purchased. Choose an edition of {{productName}} to add both to your cart."
        },
        "ADD_ADDON_SELECTION": {
          "TITLE": "Choose an edition of {{productName}}",
          "EXPLANATION": "{{childName}} is an add-on to {{productName}}, which you haven’t already purchased. Choose an edition of {{productName}} to add both to your cart."
        },
        "COMPARE_BUTTON_LABEL": "Compare editions"
      },
      "ORDER_SUMMARY": {
        "REQUIRES": "Requires {{parentName}}",
        "ADDON_OF": "Add-on of {{parentName}}"
      },
      "MANAGE_PRODUCT": {
        "MANAGE_PRODUCT_TABLE": {
          "SHOW_GROWTH_OVER": "* Show growth over",
          "PARENT_REQUIREMENT": "Requires {{name}}",
          "TOOLBAR_TEXT": "{{numShowing}} of {{numTotal}} products",
          "COLUMNS": {
            "PRODUCT": "Product",
            "ACTIVE_ACCOUNTS": "Active accounts",
            "ACTIVATIONS": "Activations*",
            "PENDING_DEACTIVATIONS": "Pending deactivations*",
            "DEACTIVATIONS": "Deactivations*",
            "GROWTH": "Growth*",
            "SELLING_IN_STORE": "Selling in store"
          },
          "ROW_ACTIONS": {
            "VIEW_MARKETING_MATERIAL": "View marketing material",
            "EDIT_IN_MARKETPLACE": "Edit in Marketplace"
          }
        }
      }
    }
  }
}
